"use client";

import { PharadayTextLogoIcon, useToast } from "@pharaday/lighthouse";
import { ContainerProvider } from "@pharaday/utils";
import { useState } from "react";

import { UnauthenticatedContainer } from "../../core/unauthenticated.container";
import StepRequestPasswordReset from "./step-request-reset-password/RequestPasswordResetForm";
import StepSentLinkSuccessNotification from "./step-sent-link-success-notification";

enum FormStepEnum {
  REQUEST_RESET_PASSWORD = "REQUEST_RESET_PASSWORD",
  SENT_LINK_SUCCESS_NOTIFICATION = "SENT_LINK_SUCCESS_NOTIFICATION",
}

const InternalRequestPasswordResetForm = () => {
  const [step, setStep] = useState<FormStepEnum>(FormStepEnum.REQUEST_RESET_PASSWORD);
  const toast = useToast();

  const handleRequestPasswordResetSuccess = () => {
    toast.success("Password reset email sent successfully");
    setStep(FormStepEnum.SENT_LINK_SUCCESS_NOTIFICATION);
  };

  return (
    <ContainerProvider value={UnauthenticatedContainer}>
      <div className="flex flex-col gap-6">
        <PharadayTextLogoIcon className="mb-4" />

        {step === FormStepEnum.REQUEST_RESET_PASSWORD && (
          <StepRequestPasswordReset onSuccess={handleRequestPasswordResetSuccess} />
        )}

        {step === FormStepEnum.SENT_LINK_SUCCESS_NOTIFICATION && <StepSentLinkSuccessNotification />}
      </div>
    </ContainerProvider>
  );
};

export default InternalRequestPasswordResetForm;
